
export const NOMINEE_MODIFICATION_SUCCESS = "NOMINEE_MODIFICATION_SUCCESS";
export const NOMINEE_MODIFICATION = "NOMINEE_MODIFICATION";


export const BSE_NOMINEE_SUBMIT_GEN_OTP_SUCCESS = "BSE_NOMINEE_SUBMIT_GEN_OTP_SUCCESS";
export const BSE_NOMINEE_SUBMIT_GEN_OTP = "BSE_NOMINEE_SUBMIT_GEN_OTP";

export const BSE_NOMINEE_RESEND_OTP_SUCCESS = "BSE_NOMINEE_RESEND_OTP_SUCCESS";
export const BSE_NOMINEE_RESEND_OTP = "BSE_NOMINEE_RESEND_OTP";